import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Text from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './ProductCounter.scss'


const ProductCounter = ({ count, className }) => {
  const message = count && count > 0 ? messages.productsLeft : messages.soldOut

  return (
    <Text
      className={cx(s.productCounter, className)}
      values={{ count }}
      message={message}
      align="center"
      size="14-24"
      bold
      uppercase
      html
    />
  )
}

ProductCounter.propTypes = {
  count: PropTypes.number,
}

ProductCounter.defaultProps = {
  count: 0,
}


export default ProductCounter
